// extracted by mini-css-extract-plugin
export var pillWrapper = "_nj-0";
export var showOverflow = "_nj-1";